export default "__VITE_ASSET__DnWTfgrU__"